import {
  getProjectPrerequisite,
  prerequisiteFromError
} from '../services/projectPrerequisite'
import {
  isPublicRouteId,
  resolveRouteValue
} from '../common/routeRecordId'

export const PROJECT_PREREQUISITE_ROUTE = 'ProjectPrerequisiteRequired'

const SELF_ROUTE_NAMES = new Set([
  '勤務表',
  '業務報告'
])

const TARGET_ROUTE_NAMES = new Set([
  '勤務表詳細',
  '業務報告詳細',
  'PublicAdminRosterDetail',
  'PublicAdminMonthlyReportDetail'
])

let installed = false

export function projectRequirementForRoute (route) {
  if (!route || route.name === PROJECT_PREREQUISITE_ROUTE) return null
  if (SELF_ROUTE_NAMES.has(route.name)) {
    return { mode: 'self', targetUserId: null }
  }
  if (!TARGET_ROUTE_NAMES.has(route.name)) return null

  const targetUserId = resolveRouteValue(route, 'user_id', 'USER') ||
    resolveRouteValue(route, 'user_ref', 'USER')
  if (!Number.isInteger(targetUserId) || targetUserId <= 0) {
    return { mode: 'invalid', targetUserId: null }
  }
  return { mode: 'target', targetUserId }
}

function prerequisiteRedirect (to, requirement, prerequisite) {
  const query = {
    from: to.fullPath,
    reason: prerequisite.reasonCode,
    scope: requirement.mode
  }
  const params = {}
  if (requirement.targetUserId != null) {
    const userRef = to.params && to.params.user_ref
    if (isPublicRouteId(userRef)) {
      query.targetRef = String(userRef).toLowerCase()
    } else {
      // encode APIの一時障害時も、数値IDをURLへ戻さず同一画面内だけ保持する。
      params.targetUserId = requirement.targetUserId
    }
  }
  return {
    name: PROJECT_PREREQUISITE_ROUTE,
    params,
    query,
    replace: true
  }
}

export default function installProjectPrerequisiteGuard (router) {
  if (installed) return
  installed = true

  router.beforeEach((to, from, next) => {
    const requirement = projectRequirementForRoute(to)
    if (!requirement) {
      next()
      return
    }
    if (requirement.mode === 'invalid') {
      next({
        name: 'AccessDenied',
        query: { reason: 'TARGET_USER_INVALID' },
        replace: true
      })
      return
    }

    getProjectPrerequisite({ targetUserId: requirement.targetUserId })
      .then(prerequisite => {
        if (prerequisite.projectConfigured) {
          next()
          return
        }
        next(prerequisiteRedirect(to, requirement, prerequisite))
      })
      .catch(error => {
        const status = error && error.response ? Number(error.response.status) : 0
        const prerequisite = prerequisiteFromError(error)
        if (prerequisite) {
          next(prerequisiteRedirect(to, requirement, prerequisite))
          return
        }
        if (status === 401) {
          next({ name: 'Login' })
          return
        }
        next({
          name: 'AccessDenied',
          query: {
            reason: status === 403
              ? 'PROJECT_PREREQUISITE_FORBIDDEN'
              : (error && error.code) || 'PROJECT_PREREQUISITE_ERROR'
          },
          replace: true
        })
      })
  })
}
